const headerNavbar = {
  'headerNavBar-navLink1': 'Über uns',
  'headerNavBar-navLink2': 'Unser Angebot',
  'headerNavBar-navLink4': 'Catering',
  'headerNavBar-navLink5': 'Standorte',
  'headerNavBar-navLink6': 'Online-shop',
  'headerNavBar-navLink7': 'Partner',
  'headerNavBar-navLink8': 'Admin'
};

export default headerNavbar;
